module.exports = __webpack_public_path__ + "img/img11.617edeea.png";